import { useEffect } from 'react';

interface SeoOptions {
  title?: string;
  description?: string;
  keywords?: string;
}

const SITE = '吃瓜路线';

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** 轻量站内 SEO 工具：设置 title / description / canonical / OG */
export function useSeo(options: SeoOptions) {
  useEffect(() => {
    const base = typeof document !== 'undefined' ? document : null;
    if (!base) return;
    const fullTitle = options.title ? `${options.title} - ${SITE}` : SITE;
    document.title = fullTitle;
    if (options.description) {
      setMeta('name', 'description', options.description);
      setMeta('property', 'og:description', options.description);
      setMeta('name', 'twitter:description', options.description);
    }
    if (options.keywords) {
      setMeta('name', 'keywords', options.keywords);
    }
    setMeta('property', 'og:title', fullTitle);
    setMeta('name', 'twitter:title', fullTitle);
    const url = typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : '/';
    let canon = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canon) {
      canon = document.createElement('link');
      canon.rel = 'canonical';
      document.head.appendChild(canon);
    }
    canon.href = url;
  }, [options.title, options.description, options.keywords]);
}